<template>
	<div class="invoice">
		<div class="btnbox">
			<el-button type="primary" size="small" @click="onadd()" v-if="appdata.myinfo.is_invoice == 1">发票申请
			</el-button>
		</div>
		<div class="tablebox">
			<div class="filterdiv filterty" ref="filter">
				<el-form :inline="true" :model="formfilter" class="demo-form-inline" size="small" label-width="0"
					v-if="filtershow">
					<el-form-item label="">
						<el-select v-model="formfilter.state" placeholder="状态">
							<el-option label="状态" value=""></el-option>
							<el-option :label="v.name" :value="v.id" v-for="(v,k) in appdata.list.fp_state" :key="k">
							</el-option>
						</el-select>
					</el-form-item>

					<el-form-item label="">
						<el-select v-model="formfilter.fp_type" placeholder="发票类型">
							<el-option label="发票类型" value=""></el-option>
							<el-option :label="v.name" :value="v.id" v-for="(v,k) in appdata.list.fp_type" :key="k">
							</el-option>
						</el-select>
					</el-form-item>

					<el-form-item label="">
						<el-select v-model="formfilter.kp_type" placeholder="开票类型">
							<el-option label="开票类型" value=""></el-option>
							<el-option :label="v.name" :value="v.id" v-for="(v,k) in appdata.list.kp_type" :key="k">
							</el-option>
						</el-select>
					</el-form-item>

					<el-form-item label="">
						<el-select v-model="formfilter.kp_reason" placeholder="开票原因">
							<el-option label="开票原因" value=""></el-option>
							<el-option :label="v.name" :value="v.id" v-for="(v,k) in appdata.list.kp_reason" :key="k">
							</el-option>
						</el-select>
					</el-form-item>
					<el-form-item label="">
						<el-date-picker v-model="formfilter.mydate" type="daterange" range-separator="至"
							start-placeholder="开始日期" end-placeholder="结束日期" format="yyyy-MM-dd"
							value-format="yyyy-MM-dd">
						</el-date-picker>
					</el-form-item>
					<el-form-item>
						<el-button type="primary" @click="onfilter">查询</el-button>
						<el-button @click="onreset">重置</el-button>
					</el-form-item>
				</el-form>
			</div>
			<div class="zk" @click="filtershow=!filtershow ">
				<span>{{filtershow ? '收起':'展开'}}</span>
			</div>
			<div class="tablediv" ref="tablediv">
				<el-table :data="list" style="width: 100%" border height="100%">
					<el-table-column prop="state_str" fixed="left" label="发票状态" align="center" header-align="center" min-width="70px">
					</el-table-column>
					<el-table-column prop="fp_no" label="发票编号" align="center" header-align="center"></el-table-column>
					<el-table-column prop="create_time_str" label="申请日期" align="center" header-align="center" width="100px">
					</el-table-column>
					<el-table-column prop="gmf_name" label="购买方姓名" align="center" header-align="center">
					</el-table-column>
					<el-table-column prop="email" label="购买方邮箱" align="center" header-align="center"></el-table-column>
					<el-table-column prop="kp_price" label="开票金额" align="center" header-align="center">
					</el-table-column>
					<el-table-column prop="price" label="费用" align="center" header-align="center" min-width="60px"></el-table-column>
					<el-table-column prop="fp_type_str" label="发票类型" align="center" header-align="center">
					</el-table-column>
					<el-table-column prop="kp_type_str" label="开票类型" align="center" header-align="center" min-width="50px">
					</el-table-column>
					<el-table-column prop="kp_reason_str" label="开票原因" align="center" header-align="center">
					</el-table-column>
					<el-table-column prop="remark" label="备注" align="center" header-align="center"></el-table-column>
					<el-table-column label="操作" fixed="right" align="center" header-align="center" width="80px">
						<template slot-scope="scope">
							<div class="operation_i">
								<span @click="onupdate(scope.row)" v-if="scope.row.state == 1">编辑</span>
								<span @click="ondetailed(scope.row)" v-if="scope.row.state != 1">详细</span>
							</div>
						</template>
					</el-table-column>
				</el-table>
			</div>
		</div>
		<div class="pagediv">
			<el-pagination background layout="prev, pager, next, sizes, total" :page-sizes="[20, 30, 50, 100, 200]"
				:current-page.sync="page" :page-size="pageSize" :total="total" v-if="total > 0"
				@current-change="handleCurrentChange" @size-change="handleSizeChange">
			</el-pagination>
		</div>

		<el-dialog :title="ruleForm.id == 0 ? '申请发票':'编辑发票'" :visible.sync="show" width="940px" :before-close="onclose">
			<div class="forms" v-if="show">
				<el-form ref="ruleForm" :model="ruleForm" :rules="rules" label-width="120px">
					<el-form-item label="发票编号" v-if="ruleForm.fp_no">
						<div>{{ruleForm.fp_no}}</div>
					</el-form-item>
					<el-form-item label="发票类型" prop="fp_type" class="item">
						<el-radio-group v-model="ruleForm.fp_type">
							<el-radio :label="v.id" v-for="(v,k) in appdata.list.fp_type" :key="k">{{v.name}}</el-radio>
						</el-radio-group>
					</el-form-item>

					<el-form-item label="开票类型" prop="kp_type" v-if="ruleForm.fp_type == 1" class="item">
						<el-radio-group v-model="ruleForm.kp_type">
							<el-radio :label="v.id" v-for="(v,k) in appdata.list.kp_type" :key="k">{{v.name}}</el-radio>
						</el-radio-group>
					</el-form-item>

					<el-form-item label="开票原因" prop="kp_reason" class="item">
						<el-select v-model="ruleForm.kp_reason" placeholder="请选择开票原因">
							<el-option :label="v.name" :value="v.id" v-for="(v,k) in appdata.list.kp_reason" :key="k">
							</el-option>
						</el-select>
					</el-form-item>

					<el-form-item label="发票明细">
						<el-table :data="ruleForm.detail" style="width: 100%" border>
							<el-table-column label="货物名称" align="center" header-align="center" width="150px">
								<template slot-scope="scope">
									<el-select v-model="ruleForm.detail[scope.$index].hwmc" size="mini"
										placeholder="请选择" style="width: 100%;" @change="onhwmc($event,scope.$index)"
										clearable>
										<el-option v-for="(v,k) in hwmclist" :key="k" :label="v.name" :value="v.name">
										</el-option>
									</el-select>
								</template>
							</el-table-column>

							<el-table-column label="规格型号" align="center" header-align="center">
								<template slot-scope="scope">
									<el-input v-model="ruleForm.detail[scope.$index].ggxh" size="mini"
										placeholder="请输入规格型号" style="width: 100%;"></el-input>
								</template>
							</el-table-column>

							<el-table-column label="单位" align="center" header-align="center" width="90px">
								<template slot-scope="scope">
									<el-select v-model="ruleForm.detail[scope.$index].dw" size="mini" placeholder="请选择"
										style="width: 100%;">
										<el-option v-for="(v,k) in dwlist" :key="k" :label="v.name" :value="v.name">
										</el-option>
									</el-select>
								</template>
							</el-table-column>

							<el-table-column label="数量" align="center" header-align="center" width="100px">
								<template slot-scope="scope">
									<el-input-number v-model="ruleForm.detail[scope.$index].sl" :controls="false"
										style="width: 100%" size="mini" @blur="ondj(scope.$index,1)"></el-input-number>
								</template>
							</el-table-column>

							<el-table-column align="center" header-align="center" width="100px">
								<template slot="header" slot-scope="scope">
									<div>单价</div>
									<div style="color: red">自动计算</div>
									<div style="color: red">无需填写</div>
								</template>
								<template slot-scope="scope">
									<el-input v-model="ruleForm.detail[scope.$index].dj" style="width: 100%" size="mini"
										:readonly="true"></el-input>
								</template>
							</el-table-column>

							<el-table-column label="金额" align="center" header-align="center" width="100px">
								<template slot-scope="scope">
									<el-input-number v-model="ruleForm.detail[scope.$index].je" :controls="false"
										style="width: 100%" size="mini" @blur="ondj(scope.$index,2)"></el-input-number>
								</template>
							</el-table-column>
						</el-table>
					</el-form-item>

					<el-form-item label="开票金额" prop="kp_price" class="item">
						<el-input-number v-model="ruleForm.kp_price" :controls="false"></el-input-number>
					</el-form-item>

					<el-form-item label="费率统计">
						<el-table :data="fltj" style="width: 100%" border>
							<el-table-column prop="lx" label="类型" align="center" header-align="center">
							</el-table-column>
							<el-table-column prop="bcje" label="本次金额" align="center" header-align="center">
							</el-table-column>
							<el-table-column prop="fl" label="费率" align="center" header-align="center">
							</el-table-column>
							<el-table-column prop="fy" label="费用" align="center" header-align="center">
							</el-table-column>
						</el-table>
					</el-form-item>

					<el-form-item label="购买方姓名" prop="gmf_name" class="item">
						<el-input v-model="ruleForm.gmf_name" placeholder="请输入购买方姓名"></el-input>
					</el-form-item>

					<el-form-item label="购买方邮箱" prop="email" class="item">
						<el-input v-model="ruleForm.email" placeholder="请输入购买方邮箱"></el-input>
					</el-form-item>

					<el-form-item label="备注" prop="remark" class="item">
						<el-input type="textarea" placeholder="" v-model="ruleForm.remark" :rows="3" maxlength="100"
							show-word-limit>
						</el-input>
					</el-form-item>

					<el-form-item label="发票保证金说明" v-if="ruleForm.id == 0">
						<p>1.申请发票后，一旦买家与代理有任何争议，请一定沟通处理好（若有困难可与平台协商）</p>
						<p>2.否则若导致买家投诉开票公司，不管投诉结果如何，平台将永久关闭发票申请功能，并扣除500元发票违约金！请代理注意！</p>
						<p class="pa">
							<el-checkbox v-model="checked">我同意以上说明</el-checkbox>
						</p>
					</el-form-item>
				</el-form>
			</div>

			<div slot="footer" class="dialog-footer">
				<el-button @click="onclose">取消</el-button>
				<el-button type="primary" @click="onsub()">确定</el-button>
			</div>
		</el-dialog>

		<el-dialog title="发票详细信息" :visible.sync="show1" width="920px" :before-close="onclose1">
			<div class="detailed">
				<div class="otitle">
					<div>发票编号: {{rowobj.fp_no}}</div>
					<div>申请日期: {{rowobj.create_time_str}}</div>
					<div>发票状态: {{rowobj.state_str}}</div>
				</div>
				<div class="item">
					<div class="ohead">
						发票申请信息
					</div>
					<div class="itable">
						<div class="qdtable">
							<div class="lh">发票类型</div>
							<div class="rv">
								{{rowobj.fp_type_str}}
							</div>
						</div>
						<div class="qdtable" v-if="rowobj.fp_type == 1">
							<div class="lh">开票类型</div>
							<div class="rv">
								{{rowobj.kp_type_str}}
							</div>
						</div>
						<div class="qdtable">
							<div class="lh">开票原因</div>
							<div class="rv">
								{{rowobj.kp_reason_str}}
							</div>
						</div>

						<div class="qdtable">
							<div class="lh">发票明细</div>
							<div class="rv tablerv">
								<el-table :data="rowobj.detail" style="width: 100%" border>
									<el-table-column prop="hwmc" label="货物名称" align="center" header-align="center"
										width="150px"></el-table-column>
									<el-table-column prop="ggxh" label="规格型号" align="center" header-align="center">
									</el-table-column>
									<el-table-column prop="dw" label="单位" align="center" header-align="center"
										width="90px"></el-table-column>
									<el-table-column prop="sl" label="数量" align="center" header-align="center"
										width="100px"></el-table-column>
									<el-table-column prop="dj" label="单价" align="center" header-align="center"
										width="100px"></el-table-column>
									<el-table-column prop="je" label="金额" align="center" header-align="center"
										width="100px"></el-table-column>
								</el-table>
							</div>
						</div>

						<div class="qdtable">
							<div class="lh">开票金额</div>
							<div class="rv">
								{{rowobj.kp_price}}
							</div>
						</div>

						<div class="qdtable">
							<div class="lh">费率统计</div>
							<div class="rv tablerv">
								<el-table :data="fltj" style="width: 100%" border>
									<el-table-column prop="lx" label="类型" align="center" header-align="center">
									</el-table-column>
									<el-table-column prop="bcje" label="本次金额" align="center" header-align="center">
									</el-table-column>
									<el-table-column prop="fl" label="费率" align="center" header-align="center">
									</el-table-column>
									<el-table-column prop="fy" label="费用" align="center" header-align="center">
									</el-table-column>
								</el-table>
							</div>
						</div>

						<div class="qdtable">
							<div class="lh">购买方姓名</div>
							<div class="rv">
								{{rowobj.gmf_name}}
							</div>
						</div>
						<div class="qdtable">
							<div class="lh">购买方邮箱</div>
							<div class="rv">
								{{rowobj.email}}
							</div>
						</div>
						<div class="qdtable">
							<div class="lh">备注</div>
							<div class="rv">
								{{rowobj.remark}}
							</div>
						</div>
					</div>
				</div>
				<div class="item">
					<div class="ohead">
						发票审核情况
					</div>
					<div class="itable">
						<div class="qdtable">
							<div class="lh">备注</div>
							<div class="rv">
								{{rowobj.audit_remark}}
							</div>
						</div>
					</div>
				</div>

				<div class="item" v-if="rowobj.state == 4">
					<div class="ohead">
						发票发出情况
					</div>
					<div class="itable">
						<div class="qdtable">
							<div class="lh">备注</div>
							<div class="rv">
								{{rowobj.send_remark}}
							</div>
						</div>
					</div>

					<div class="itable">
						<div class="qdtable">
							<div class="lh">发票图片</div>
							<div class="rv">
								<div class="imgdiv">
									<el-image class="img" :src="v" :preview-src-list="rowobj.pic"
										v-for="(v,k) in rowobj.pic" :key="k">
									</el-image>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</el-dialog>
	</div>
</template>

<script>
	export default {
		name: 'Invoice',
		data() {
			return {
				list: [],
				page: 1,
				pageSize: 20,
				total: 0,

				show: false,
				filtershow: true,
				show1: false,

				formfilter: {
					state: "",
					fp_type: "",
					kp_type: "",
					kp_reason: "",
					mydate: [],
					btime: "",
					etime: "",
				},

				ruleForm: {
					id: 0,
					fp_no: "",
					fp_type: 1,
					kp_type: 1,
					kp_reason: "",
					kp_price: "",
					email: "",
					detail: [],
					gmf_name: "",
					remark: "",
					price: 0,
				},

				rules: {
					fp_type: [{
						required: true,
						message: '请选择发票类型',
						trigger: 'change'
					}],

					kp_type: [{
						required: true,
						message: '请选择开票类型',
						trigger: 'change'
					}],

					kp_reason: [{
						required: true,
						message: '请选择开票原因',
						trigger: 'change'
					}],

					kp_price: [{
						required: true,
						message: '请输入开票金额',
						trigger: 'blur'
					}],

					gmf_name: [{
						required: true,
						message: '请输入购买方姓名',
						trigger: 'blur'
					}],

					remark: [{
						required: true,
						message: '请填写备注',
						trigger: 'blur'
					}],

					email: [{
							required: true,
							message: '请输入邮箱地址',
							trigger: 'blur'
						},
						{
							type: 'email',
							message: '请输入正确的邮箱地址',
							trigger: 'blur'
						}
					]
				},

				checked: false,

				hwmclist: [{
					name: '运动服'
				}, {
					name: '运动鞋'
				}, {
					name: '运动配件'
				}, {
					name: '服装'
				}, {
					name: '鞋'
				}, {
					name: '体育用品'
				}],

				dwlist: [{
					name: '件'
				}, {
					name: '双'
				}, {
					name: '个'
				}, {
					name: '套'
				}, {
					name: '批'
				}],

				fltj: [{
					lx: '独立开票金额',
					bcje: 0,
					fl: '4%',
					fy: 0,
				}],

				rowobj: {},
			}
		},

		inject: ['appdata'],

		mounted() {
			this.onlist();
			this.resizeObserver = new ResizeObserver(entries => {
				for (let entry of entries) {
					const cr = entry.contentRect;
					var num = Number(cr.height) + 30;
					this.$refs.tablediv.style.height = "calc(100% - " + num + "px)";
				}
			});
			this.resizeObserver.observe(this.$refs.filter);
		},

		beforeDestroy() {
			if (this.resizeObserver) {
				this.resizeObserver.disconnect();
			}
		},

		watch: {
			'ruleForm.kp_price': {
				handler: function(newV, oldV) {
					this.fltj[0].bcje = newV;
					this.fltj[0].fy = (Number(newV) * 0.04).toFixed(2);
				},
				deep: true,
			}
		},

		methods: {
			handleCurrentChange() {
				this.onlist();
			},

			handleSizeChange(val) {
				this.page = 1;
				this.pageSize = val;
				this.onlist();
			},

			onfilter() {
				this.page = 1;
				this.onlist();
			},

			onreset() {
				this.formfilter = {
					state: "",
					fp_type: "",
					kp_type: "",
					kp_reason: "",
					mydate: [],
					btime: "",
					etime: "",
				};
				this.page = 1;
				this.onlist();
			},

			onlist() {
				var obj = JSON.parse(JSON.stringify(this.formfilter));
				obj.btime = obj.mydate[0];
				obj.etime = obj.mydate[1];
				obj.page = this.page;
				obj.limit = this.pageSize;
				this.$axios.post('api/user/user_invoice_list', obj).then(res => {
					if (res.data.code == 0) {
						this.total = res.data.data.count;
						this.list = res.data.data.list;
					} else {
						this.$message.error(res.data.message);
					}
				}).catch(err => {
					console.log(err)
				})
			},

			onadd() {
				this.show = true;
				for (let i = 0; i < 5; i++) {
					var obj = {
						hwmc: "",
						ggxh: "",
						dw: "件",
						sl: "",
						dj: "",
						je: "",
					};
					this.ruleForm.detail.push(obj);
				}
			},

			onclose() {
				this.show = false;
				this.ruleForm = {
					id: 0,
					fp_no: "",
					fp_type: 1,
					kp_type: 1,
					kp_reason: "",
					kp_price: "",
					detail: [],
					gmf_name: "",
					remark: "",
					email: "",
					price: 0
				};
				this.checked = false;
			},

			onsub() {
				this.$refs['ruleForm'].validate((valid) => {
					if (valid) {
						var sun = 0;
						var arr = [];
						var karr = [];
						if (this.ruleForm.kp_price == 0) {
							this.$message.error('开票金额不能为0');
							return;
						}

						this.ruleForm.detail.forEach((v, k) => {
							if (v.hwmc && v.ggxh && v.sl && v.je) {
								arr.push(v);
							} else {
								if (!v.hwmc && !v.ggxh && !v.sl && !v.je) {

								} else {
									karr.push(k);
								}
							}
							
							if (v.je) {
								sun = sun + v.je;
							}
						})

						if (!this.checked) {
							this.$message.error('请同意发票保证金说明');
							return;
						}

						if (this.ruleForm.kp_price <= 0) {
							this.$message.error('开票金额不能为0');
							return;
						}

						if (this.ruleForm.kp_price < sun) {
							this.$message.error('开票金额小于明细的总金额');
							return;
						}

						if (arr.length == 0) {
							this.$message.error('必须填写一条发票明细');
							return;
						}

						if (karr.length > 0) {
							this.$message.error('发票明细数据不完整，请认真检查');
							return;
						}

						var obj = JSON.parse(JSON.stringify(this.ruleForm));
						obj.detail = JSON.stringify(obj.detail);
						obj.price = this.fltj[0].fy;
						if (obj.fp_type == 2) {
							obj.kp_type = 0;
						}
						this.$axios.post('api/user/user_invoice_save', obj).then(res => {
							if (res.data.code == 0) {
								this.$message.success('操作成功');
								this.onclose();
								this.onlist();
							} else {
								this.$message.error(res.data.message);
							}
						}).catch(err => {
							console.log(err)
						})
					}
				})
			},

			onhwmc(v, n) {
				if (v == "运动服" || v == "服装") {
					this.ruleForm.detail[n].dw = '件';
				}

				if (v == '运动鞋' || v == '鞋') {
					this.ruleForm.detail[n].dw = '双';
				}

				if (v == '运动配件' || v == '体育用品') {
					this.ruleForm.detail[n].dw = '个';
				}
			},

			ondj(n, i) {
				if (this.ruleForm.detail[n].sl && this.ruleForm.detail[n].je) {
					this.ruleForm.detail[n].dj = (Number(this.ruleForm.detail[n].je) / Number(this.ruleForm.detail[n].sl))
						.toFixed(2);
				}
				if (i == 2) {
					this.ruleForm.kp_price = 0;
					this.ruleForm.detail.forEach((v, k) => {
						if (v.je) {
							this.ruleForm.kp_price = this.ruleForm.kp_price + v.je;
						}
					})
				}
			},

			onupdate(obj) {
				for (let key in this.ruleForm) {
					if (key == 'detail') {
						this.ruleForm[key] = JSON.parse(obj[key]);
					} else {
						this.ruleForm[key] = obj[key];
					}
				}
				this.show = true;
				this.checked = true;
			},

			ondetailed(obj) {
				this.rowobj = JSON.parse(JSON.stringify(obj));
				var arr = [];
				JSON.parse(this.rowobj.detail).forEach((v, k) => {
					if (v.hwmc) {
						arr.push(v);
					}
				})
				this.rowobj.detail = arr;
				this.rowobj.pic = this.rowobj.pic.split(',');
				this.fltj = [{
					lx: '独立开票金额',
					bcje: this.rowobj.kp_price,
					fl: '4%',
					fy: this.rowobj.price,
				}];
				this.show1 = true;
			},

			onclose1() {
				this.rowobj = {};
				this.show1 = false;
				this.fltj = [{
					lx: '独立开票金额',
					bcje: 0,
					fl: '4%',
					fy: 0,
				}]
			},
		}
	}
</script>

<style scoped lang="less">
	.invoice {
		height: 100%;
	}

	.filterty .el-date-editor {
		width: 250px;
	}

	.tablebox {
		height: calc(100% - 104px);
	}

	/deep/ .el-input-number .el-input__inner {
		text-align: left;
	}

	/deep/ .item .el-select {
		width: 400px;
	}

	/deep/ .item .el-input-number {
		width: 400px;
	}

	/deep/ .item .el-input {
		width: 400px;
	}

	/deep/ .item .el-textarea {
		width: 400px;
	}

	.detailed {
		.otitle {
			width: 100%;
			height: 40px;
			display: flex;
			align-items: center;
			justify-content: space-between;
			border: 1px solid #EBEEF5;
			border-bottom: none;

			div {
				width: 33%;
				height: 40px;
				border-right: 1px solid #EBEEF5;
				display: flex;
				align-items: center;
				justify-content: center;
				font-size: 14px;
				color: #606266;
			}

			div:last-child {
				border-right: none;
			}
		}

		.item {
			width: 100%;
			margin-bottom: 10px;

			.ohead {
				width: 100%;
				height: 40px;
				font-size: 14px;
				font-weight: bold;
				color: #000;
				display: flex;
				align-items: center;
				justify-content: center;
				background-color: #EBEEF5;

				span {
					color: #ff4714;
					margin-left: 6px;
				}
			}

			.qdtable {
				width: 100%;
				display: flex;
				font-size: 14px;

				>div {
					min-height: 40px;
					display: flex;
					align-items: center;
					border-bottom: 1px solid #EBEEF5;
				}

				.lh {
					width: 180px;
					min-width: 180px;
					justify-content: center;
					border-right: 1px solid #EBEEF5;
				}

				.rv {
					width: 100%;
					padding-left: 10px;
					display: flex;

					div {
						width: 50%;
					}

					.time {
						padding: 9px;
						border-left: 1px solid #EBEEF5;

						p {
							line-height: 20px;
						}
					}

					.img {
						width: 50px !important;
						height: 50px;
						margin-right: 20px;
						padding: 10px 0;
					}

					.imgdiv {
						display: flex;
						flex-wrap: wrap;
					}
				}

				.tablerv {
					padding: 10px;
				}
			}
		}
	}
</style>



// WEBPACK FOOTER //
// src/components/buyer/invoice.vue